import { FaUserSecret } from 'react-icons/fa';
import { useImpersonate } from '../hooks/useImpersonate';

export const Impersonate = () => {
  const {
    businessSelectionModal,
    businessSelectForm,
    passwordConfirmForm,
    passwordModalOpen,
    setPasswordModalOpen,
    cancelImpersonation,
    businessList,
    impersonate,
  } = useImpersonate();
  return (
    <>
      {impersonate?.impersonate ? (
        <div onClick={()=>cancelImpersonation()} className="w-8 h-8 mx-2 bg-green-500 animate-blink rounded-full justify-center flex items-center cursor-pointer">
          <FaUserSecret
            onClick={() => setPasswordModalOpen(true)}
            className="text-white cursor-pointer"
            color="#fff"
          />
        </div>
      ) : (
        <FaUserSecret
          onClick={() => setPasswordModalOpen(true)}
          className="mx-2 text-white cursor-pointer"
          color="#fff"
        />
      )}

      {passwordModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md">
            <h2 className="text-xl text-gray-900 mb-4">
              Enter Password to start Impersonation
            </h2>
            <input
              type="password"
              name="password"
              onChange={passwordConfirmForm.handleChange}
              className="w-full text-gray-900 border border-gray-300 rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Password"
            />
            <small className="text-red-500">
              {passwordConfirmForm?.errors?.password}
            </small>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => cancelImpersonation()}
                className="px-4 py-2 rounded-lg border bg-red-500 text-white"
              >
                Cancel
              </button>
              <button
                disabled={passwordConfirmForm.isSubmitting}
                onClick={passwordConfirmForm.handleSubmit}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white"
              >
                {passwordConfirmForm.isSubmitting ? 'Loading...' : 'Submit'}
              </button>
            </div>
          </div>
        </div>
      )}

      {businessSelectionModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-lg">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Choose an Option</h2>

            <select
              name="business"
              onChange={businessSelectForm.handleChange}
              className="text-gray-900 w-full border border-gray-300 rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">-- Select Business --</option>
              {businessList.map((business, index) => {
                return (
                  <option key={index} value={business.id}>
                    {business.businessName} ({business.oemName})
                  </option>
                );
              })}
            </select>
            <small className="text-red-500">
              {businessSelectForm?.errors?.business}
            </small>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => cancelImpersonation()}
                className="px-4 py-2 rounded-lg border bg-red-500 text-white"
              >
                Cancel
              </button>
              <button
                onClick={businessSelectForm.handleSubmit}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
